/**
 * GraphHeaderBar — the top bar of a drilled-in graph view (a state machine, a
 * state's inner graph, a transition rule): ← Back, a breadcrumb whose last
 * crumb is where you are, and the view's own controls on the right.
 *
 * It is a band in the layout, not an overlay: the canvas sits below it, so
 * nothing the view adds to the right can land on the breadcrumb, and a long
 * name truncates instead of running under a button. CanvasHint is the one-line
 * how-to that used to share that row; it now sits in the canvas corner.
 */
export function GraphHeaderBar({ onBack, crumbs = [], children }) {
  const last = crumbs.length - 1
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0,
      minHeight: 40, padding: '6px 12px', boxSizing: 'border-box',
      background: 'var(--m-panel)', borderBottom: '1px solid var(--m-line)',
      fontFamily: 'var(--m-font)',
    }}>
      <button onClick={onBack} style={headerBtn}>← Back</button>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, minWidth: 0, fontSize: 11 }}>
        {crumbs.map((c, i) => (
          <span key={i} style={{ display: 'contents' }}>
            {i > 0 && <span style={{ color: 'var(--m-fg-3)' }}>/</span>}
            <span style={{
              color: i === last ? 'var(--m-fg)' : 'var(--m-fg-3)',
              fontWeight: i === last ? 'bold' : 'normal',
              whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
            }}>{c}</span>
          </span>
        ))}
      </div>
      <div style={{ flex: 1 }} />
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
        {children}
      </div>
    </div>
  )
}

export function CanvasHint({ children }) {
  return (
    <div style={{
      position: 'absolute', left: 12, top: 10, zIndex: 5, pointerEvents: 'none',
      color: 'var(--m-fg-3)', fontSize: 10, fontFamily: 'var(--m-font)',
    }}>
      {children}
    </div>
  )
}

export const headerBtn = {
  background: 'var(--m-panel-hi)', border: '1px solid var(--m-line)', color: 'var(--m-fg-2)',
  borderRadius: 'var(--m-radius-sm)', padding: '4px 10px', fontSize: 11,
  fontFamily: 'var(--m-font)', cursor: 'pointer', flexShrink: 0,
}

export const headerLabel = {
  color: 'var(--m-fg-3)', fontSize: 9, fontWeight: 'bold', letterSpacing: 1,
  textTransform: 'uppercase',
}
